const fr =  {
    global:{
        general_error: "Oups, une erreur s'est produite !",
        yes: "oui",
        no: "non",
        cancel: "Annuler",
        close: "Fermer",
        save: "Enregistrer",
        send: "Envoyer",
        confirm_1: "Valider",
        confirm_2: "Confirmer",
        next: "Suivant",
        delete: "Supprimer",
        ok: "Ok",
        publish: "Publier",
        cv_candidat: "CV du candidat",
        login: "Se connecter",
        edit: "Modifier",
        renew: "Renouveler",
        archive: "Archiver"
    },
    messages: {
        error: {
            register: "Une erreur s'est produite lors de la création du compte",
            login: "Email et/ou mot de passe incorrect(s)",            
            forgot_password: "Une erreur s'est produite lors de l'envoi du mail de renouvellement du mot de passe",
            edit: "Une erreur s'est produite lors de l'édition du profil",
            reset_passowrd: "Le mot de passe acutel saisie est incorrect",
            annonce_add: "Une erreur s'est produite lors de l'ajout d'une annonce",
            annonce_edit: "Une erreur s'est produite lors de l'edition d'une annonce",
            annonce_renew: "Une erreur s'est produite lors du renouvellement d'une annonce",
            annonces_get: "Une erreur s'est produite lors du chargement des annonces",
            resend_activation_email: "Une erreur s'est produite lors de l'envoie du mail d'activation"       
        }, 
        success: {
            login: "",
            edit: "Profil édité avec succès !",
            reset_passowrd: "Votre mot de passe a été mis à jour",
            annonce_add: "Votre annonce a été ajoutée",
            annonce_edit: "Votre annonce a été éditée",
            annonce_renew: "Votre annonce a été renouvelllée",
        },
        matching_algo: {
            company: "Candidats recommandés selon nos algorithmes de matching",
            candidate: "Entreprises recommandées selon nos algorithmes de matching"
        },
        validation: {
            annonce: {
                nbr_positions: {
                    err_1: "Champ obligatoire",
                    err_2: "Le nombre de postes doit être supérieur à 0"
                },
                address: "Champ obligatoire",
                experience: "Champ obligatoire",
                contract: "Champ obligatoire",
                fonctions: "Champ obligatoire",
                salary_min: "Champ obligatoire",
                salary_max: "Champ obligatoire",
                description: "Champ obligatoire",
            },
            reset: {
                new_password: {
                    err_1: "Champ obligatoire",
                    err_2: "Le nouveau mot de passe doit avoir au moins 8 caractères",
                },
                password: {
                    err_1: "Champ obligatoire",
                    err_2: "Le mot de passe doit avoir au moins 8 caractères",
                },
            },
            forgot: {
                err_1: "Entrez une adresse mail valide",
                err_2: "Champ obligatoire"
            },
            login: {
                email: {
                    err_1: "Entrez une adresse mail valide",
                    err_2: "Champ obligatoire"
                },
                password: {
                    err_1: "Le mot de passe doit avoir au moins 8 caractéres",
                    err_2: "Champ obligatoire"
                }
            },
            register: {
                company: {
                    name: "Champ obligatoire",
                    address: "Champ obligatoire",
                    siret: "Champ obligatoire",
                    activities: "Champ obligatoire",
                    fonctions: "Poste à pourvoir obligatoire",
                    email: {
                        err_1: "Entrez une adresse mail valide",
                        err_2: "Adresse mail obligatoire"
                    },
                    password: {
                        err_1: "Le mot de passe doit avoir au moins 8 caractères",
                        err_2: "Champ obligatoire"
                    },
                    isChecked: "Vous devez accepter les conditions d'utilisation et la politique de confidentialité de VisioJob"
                },
                candidate: {
                    first_name: "Champ obligatoire",
                    last_name: "Champ obligatoire",
                    email: {
                        err_1: "Entrer une adresse mail valide",
                        err_2: "Champ obligatoire"
                    },
                    password: {
                        err_1: "Le mot de passe doit avoir au moins 8 caractères",
                        err_2: "Champ obligatoire"
                    },
                    phone: {
                        err_1: "Entrez un numero de téléphone valide ex: 0666666666",
                        err_2: "Champ obligatoire"
                    },
                    isChecked: "Vous devez accepter les conditions d'utilisation et la politique de confidentialité de VisioJob"
                }
            },
            edit: {
                company: {
                    name: "Champ obligatoire",
                    address: "Champ obligatoire",
                    siret: "Champ obligatoire",
                    activities: "Champ obligatoire",
                    fonctions: "Champ obligatoire",
                    phone: "Champ obligatoire",
                    email: {
                        err_1: "Entrez une adresse mail valide",
                        err_2: "Champ obligatoire"
                    }
                },
                candidate: {
                    first_name: "Champ obligatoire",
                    last_name: "Champ obligatoire",
                    email: {
                        err_1: "Entrer une adresse mail valide",
                        err_2: "Champ obligatoire"
                    },
                    phone: "Champ obligatoire",
                    preferred_contract: "Champ obligatoire",
                    activities: "Champ obligatoire",
                    fonctions: "Champ obligatoire",
                    address: "Champ obligatoire"
                }
            }
        },
        popup: {
            no_cv: "Pas de CV disponible pour ce candidat !",
            delete_msg: "Êtes-vous sûr de vouloir supprimer votre CV ?",
        },
    },
    nav_bar: {
        logout: "Déconnexion",
        // company
        search_candidates: "Recherche",
        my_annonces: "Mes annonces",
        favourite_candidates: "Candidats favoris",
        profile: "Profil",
        add_annonce: "Ajouter une annonce",
        // candidate
        search_job: "Recherche d’emploi",
        favourite_offers: "Offres favorites",
        my_profile: "Mon profil",
        home: "Accueil"
    },
    fields:{
        // global
        email: "Adresse mail",
        password: "Mot de passe",
        candidates: {
            // register
            first_name: "Nom",
            last_name: "Prénom",
            phone: "N°Téléphone",
            // search job
            metier: "Métier",
            contracts: "Type de contrat",
            localization: "Ville, département, région...",
            activities: "Secteur d’activité",
            // profile
            permis: "Permis de conduire",
            has_vehicle: "Véhiculé",
            handicap: "Situation de Handicap",
            activities_wished: "Type de contracts recherchés",
            experience: "Niveau d’expérience",
            situation_familiale: "Situation familiale",
            situation_pro: "Situation professionnelle",
            birthday: "Date de naissance",
            preferred_contracts: "Type de contrat"
        },
        company: {
            //register
            address: "Adresse",
            name: "Nom de l’entreprise",
            siege: "Siège social",
            siret: "N°Siret",
            activities: "Secteur d’activité",
            fonctions: "Postes à pourvoir",
            // search candidates
            metier: "Métier",
            contracts: "Type de contrat",
            localization: "Ville, département, région...",
            experience: "Niveau d’expérience",
            contract: "Types de contrats recherchés",
            // profile
            size: "Nombre d'employés",
            founded_in: "Année de création",
            web_site: "Site web",
            phone: "Numéro de téléphone",
            description: "Description de l’entreprise",
            // annonce
            nbr_positions: "Nombre de postes",
            contracts: "Type de contrat",
            experience: "Niveau d’expérience",
            salary_min: "Salaire annuel minimum brut",
            work_location: "Lieu de travail",
            salary_max: "Salaire annuel maximum brut",
            total_apply: "Total des postulants",
            // cv
            birth_date: "Date de naissance",
            rayon_search: "Rayon de recherche d’emploi",
            situation: "Situation",
            has_permis: "Permis de conduire",
            has_vehicule: "Véhiculé",
            handicap: "Situation de Handicap",
            civil_status: "Situation familiale",
            // purchase
            code_postal: "Code postal",
            city: "Ville"
        }
    },
    landing_page: {
        title: "Le réseau francophone de <bold>l’emploi</bold>",
        find: "Trouvez",
        offer: "Proposez",
        login: "Se connecter",
        register_free: "Inscription gratuite",
        mobile_app: "Disponible sur",
        candiadate: {
            title: "Tentez de trouver un emploi en 5 étapes :",
            step_1: "Téléchargez l’application",
            step_2: "Inscrivez-vous (Nom, Prénom, Fonction etc.…) Après avoir reçus un mail confirmant votre inscription",
            step_3: "Connectez-vous",
            step_4: "Finalisez votre profil en y ajoutant une Photo et en réalisant une vidéo de présentation",
            step_5: "Postulez aux annonces d’emplois",
        },
        company: {
            title: "Recrutez plus facilement et plus rapidement les profils candidats qui correspondent à vos demandes en 5 points :",
            step_1: "Téléchargez l’application",
            step_2: "Inscrivez votre entreprise (Nom de l’entreprise, secteur d’activité etc.…) Après vérification, vous recevrez un mail validant votre inscription",
            step_3: "Connectez-vous",
            step_4: "Déposez vos annonces de recrutement tout en ayant accès aux différents profils de demandeurs d’emplois correspondant à votre secteur d’activité et plus! ",
            step_5: "Recevez des notifications à chaque fois qu’un candidat postule à une de vos annonces"
        }
    },
    auth: {
        login: {
            title: "Connectez-vous et",
            find: "Trouvez",
            offer: "Proposez",
            a_job: "un job",
            forgot_password: "Mot de passe oublié ?",
            login: "Se connecter",
            no_account: "Vous n’avez pas de compte ?",
            create_person_account: "Créer un compte candidat",
            create_company_account: "Créer un compte entreprise",
        },
        forgot_password: {
            title: "Mot de passe oublié",
            description: "Saisissez l'adresse mail associée à votre compte pour recevoir le code de vérification pour réinitialiser votre mot de passe oublié",
            success: "Un mail de réinitialisation de votre mot de passe vous a été envoyé"
        },
    },
    not_found: {
        login: "Se connecter",
        home: "Accueil",
        description: "Nous vous prions de nous excuser, la page à laquelle vous essayez d'accéder n'existe pas."
    },
    /* Company */
    company: {
        register: {
            title: {
                t_1: "Inscrivez-vous ",
                t_2: "rapidement ",
                t_3: "et"
            },
            offer_a_job: "Proposez un job",
            question_fonctions: "Quels sont les postes à pourvoir en général ?",
            conditions: "En créant un compte, vous acceptez les conditions d'utilisation et la politique de confidentialité de VisioJob.",
            button: "Créer un compte",
            success: "Votre compte VisioJob a été créé, nous venons de vous envoyer un email de confirmation afin que vous puissiez valider l'ouverture de votre compte",
            conditions: {
                t_1: "En créant un compte, vous acceptez",
                t_2: "les conditions d'utilisation d’utilisation et la politique de confidentialité",
                t_3: "de VisioJob",
            },
            inactive_account: "Merci de confirmer votre adresse e-mail avant de pouvoir utiliser l'application VisioJob, n'oubliez pas de vérifier dans vos spams. Rien reçu ? Demandez le renvoi d'un nouveau e-mail d'activation",
            account_pending_review: "Votre compte VisioJob est en attente de validation par notre équipe, vous receverez un email de validation aprés confirmation de celui-ci"
        },
        search_candidates: {
            title: "Recherche des candidats",
            title_recommendation: "Nos recommandations",
            profile_incompleted: "Compléter votre profil pour vous rendre visible aux candidats et recevoir des candidatures",
            complete_profile: "Compléter mon profil",
            fonctions: "Métier",
            contracts: "Type de contrat",
            localization: "Ville, département, région...",
            experience: "Niveau d’expérience",
            search: "Rechercher",
            search_none: "Pas de candidats disponibles pour l’instant",
            search_available: "Candidats disponibles",
            search_result: "Résultats de recherche",
            candidates: "candidats",
            applied: "Postulé",
        },
        favourite_candidates: {
            title: "Profils favoris",
            description: "Pour enlever un candidat de vos favoris, cliquez juste sur une étoile",
            favourites_none: "Pas de candidats dans les favoris",
            applied: "Postulé",
        },
        candidate_cv: {
            title: "CV du candidat",
            video_none: "Ce candidat n’a pas encore mis une vidéo de présentation",
            check_cv: "Consulter son CV",
            phone: "N°Tél",
            email: "E-mail"
        },
        profile: {
            main: {
                title: "Profil",
                about: "À propos",
                company_info: "Informations sur l’entreprise",
                edit_password: "Modifier le mot de passe",
                edit_profile: "Éditer le profil",
                purchase: "Paiement et facturation",
                allow_notifications: "Autoriser les notifications",
                email_notif: "Notifications par mail",
                push_notif: "Notifications push",
            },
            edit: {
                title: "Édition du profil",
                optional_info_1: "Informations complémentaires",
                optional_info_2: "(facultatives)",
            },
            purchase: { // incomplete
                title: "Paiement et facturation",
                desc_1: "Saisissez les coordonnées de la carte bancaire avec laquelle vous pourrez payer les publications de vos offres d’emploi",
                desc_2: "Saisissez les coordonnées de votre entreprise à utiliser dans vos factures",
                full_name_card_holder : "Prénom et nom du titulaire de la carte",
                card_number: "Numéro de la carte",
                expiration_date: "Date d’expiration",
                verification_code: "Code de vérification",
                city_postal_colde: "Ville, code postal"
            },
            reset_password: {
                title: "Modification du mot de passe",
                current_password: "Mot de passe actuel",
                new_password: "Nouveau mot de passe",
                helper: "Au moins huit caractères",
                success: "Mot de passe créé avec succès !"
            }
        },
        annonce: {
            details_annonce: {
                title: "Détails de l’annonce",
                number_position: "Nombre de postes",
                contracts: "Type de contrat",
                experience: "Niveau d’expérience",
                salary_yearly_min: "Salaire annuel minimum brut",
                work_location: "Lieu de travail",
                salary_yearly_max: "Salaire annuel maximum brut",
                total_apply: "Total des postulants"
            },
            main_annonce: {
                title: "Mes annonces",
                add: "Ajouter une annonce",
                annonce_none: "Aucune annonce n’a été publiée pour le moment",
                state: {
                    active: "active",
                    pending: "En attente d’approbation",
                    archived: "Archivée",
                    refused: "Refusée"
                },
                action: {
                    amend: "Modifier",
                    archive: "Archiver",
                    renew: "Renouveler"
                },
                contracts: "Contrats",
                total_apply: "Total postulants",
                publishedOn: "Publié le"
            },
            add_annonce: {
                title: "Nouvelle annonce",
                step_1: "Étape 1/2 : Critères de ciblage",
                step_2: "Étape 2/2 : Paiement et facturation",
                description_1: "Ciblez des candidats selon les critères suivants :",
                description_2: "Saisissez les coordonnées de la carte bancaire avec laquelle vous allez payer les frais de votre annonce",
                desc_annonce: "Description de l’annonce...",
                cart_owner: "Prénom et nom du titulaire de la carte",
                description_3: "Saisissez les coordonnées de votre entreprise à ajouter à votre facture",
                cart_number: "Numéro de la carte",
                cart_expiry: "Date d’expiration",
                cart_cvc: "Code de vérification",
            },
            edit_annonce: {
                title: "Modification de l’annonce",
                description: "Description de l’annonce (facultative)",
            },
            renew_annonce: {
                title: "Renouvelement de l’annonce",
                description: "Description de l’annonce (facultative)",
            },
            archive: {
                title: "Archivage",
                description: "Confirmez-vous l’archivage de cette annonce ?",
            }
        },
    },
    /* Candidate */
    candidate: {
        register: {
            title: {
                t_1: "Inscrivez-vous ",
                t_2: "gratuitement ",
                t_3: "et"
            },
            find: "Trouvez un job",
            conditions: "En créant un compte, vous acceptez les conditions d'utilisation et la politique de confidentialité de VisioJob.",
            button: "Créer un compte",
            success: "Compte créé avec succès !",
        },

        search_job: {
            main: {
                page_title: "VisioJob | Recherche d'emploi",
                title: "Recherche d'emploi",
                title_recommendation: "Nos recommendations",
                profile_incompleted: "Compléter votre profil pour accéder aux offres et vous rendre visible auprès des entreprises  ",
                complete_profile: "Compléter mon profil",
                available_offre: "offres disponibles",
                salary_yearly_min: "Salaire annuel minimum brut",
                Indifferent: "Indifférent",
                applied: "Postulé",
                search_none: "Aucune offre ne correspond aux termes de recherche spécifiés",
                salary_min: "Salaire annuel minimum brut",
                available_offers: "offres disponibles",
                show_more: "Afficher plus",
            },
            details: {
                title: "Détails de l’annonce",
                apply: "Postuler",
                applied: "Déjà Postulé",
                number_position: "Nombre de postes",
                contracts: "Type de contrat",
                experience: "Niveau d’expérience",
                salary_yearly_min: "Salaire annuel minimum brut",
                work_location: "Lieu de travail",
                salary_yearly_max: "Salaire annuel maximum brut",
                not_found: "404 — Annonce non trouvée !",
            },
            applying: {
                title: "Candidature",
                description: "Confirmez-vous votre candidature à cette annonce ?",
            }
        },
        favourite_offers: {
            page_title: "VisioJob | Offres favorites",
            title: "Offres pour lesquelles je suis intéréssé",
            description: "Pour enlever une offre des favoris, cliquez sur une étoile",
            applied: "Postulé",
        },
        profile: {
            main: {
                page_title: "VisioJob | Mon profil",
                title: "Mon profil",
                interested_opportunities: "Intéressé(e) par de nouvelles opportunités",
                edit_password: "Modifier le mot de passe",
                edit_profile: "Éditer le profil",
                allow_notifications: "Autoriser les notifications",
                email_notif: "Notifications par mail",
                push_notif: "Notifications push",
                add_cv: "Ajouter mon CV",
                check_cv: "Consulter mon CV",
                add_video: "Présentez-vous en vidéo en utilisant l’application VisioJob"
            },
            edit: {
                title: "Édition du profil",
                optional_info: "Informations complémentaires (facultatives)",
                rayon_search: "Rayon de recherche d’emploi à partir de votre adresse"
            },
            purchase: { // incomplete
                title: "Édition du profil"
            },
            reset_password: {
                title: "Modification du mot de passe",
                current_password: "Mot de passe actuel",
                new_password: "Nouveau mot de passe"
            }
        },
    },
    multiselect: {
        allItemsAreSelected: "Tous sélectionnés.",
        clearSearch: "Vider",
        noOptions: "Aucun élément",
        search: "Recherche",
        selectAll: "Tout sélectionner",
        selectSomeItems: "Sélectionner..."
    }

}

export default fr